import { Center } from '@chakra-ui/react'
import React from 'react'
import { Spinner } from '@chakra-ui/react';

interface ILoadingWrapper {
    loading: boolean;
    children: React.ReactNode;
}

export default function LoadingWrapper(props: ILoadingWrapper) {
    return (
        <>
            {props.loading ? <Center><Spinner /></Center> : props.children}
        </>
    )
}
